module.exports = __webpack_public_path__ + "01_short_gold.705ce06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_short_gold.png
// module id = +lQH
// module chunks = 0